import { mapState, mapGetters, mapMutations } from 'vuex'
import MultipleFileInput from '@/components/Ui/MultipleFileInput'
import Constants from '@/utils/Constants'
import Validator from '@/utils/Validator'

export default {
  name: 'TypeSoundBroadcast',
  components: {
    MultipleFileInput
  },
  data () {
    return {
      input: {
        soundFile: null,
      }
    }
  },
  mounted () {
    this.init()
    this.setValidate(this.formIsValid)
  },
  computed: {
    ...mapState({
      values: state => state.noticeForm.values
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
    }),

    // validate
    formIsValid () {
      return Validator.validFile(this.input.soundFile)
    },

    // post用にjsonbを取得
    jsonb () {
      let jsonb = {}
      if (this.input.soundFile !== null) {
        jsonb.soundFile = this.input.soundFile
      }
      return jsonb
    }
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate(this.formIsValid)
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations({
      setValidate: 'noticeForm/setValidate'
    }),

    init () {
      Object.keys(this.input)
        .forEach(key => {
          if (this.values.inpDeliveryContents &&
            this.values.inpDeliveryContents[key]) {
            this.input[key] = this.values.inpDeliveryContents[key]
          }
        })
    },

    // ファイル登録
    changeFile ({index, file}) {
      this.input.soundFile = file
    },
  }
}
